import {EventEmitter} from 'events'
import {HeadingAreaMessageParams} from './HeadingAreaMessageComponent'
import {BaseHttpError} from '../../../network/errors/baseHandling/BaseHttpError'

export default class EventEmitterEx extends EventEmitter {
    waitNextEventLoop(time?: number): Promise<() => {}> {
        return new Promise(resolve => {
            setTimeout(resolve, time)
        })
    }

    async showLoading(message?: string): Promise<void> {
        await this.waitNextEventLoop()
        this.emit('showLoading', message)
    }

    changeLoadingMessage(message: string): void {
        this.emit('changeLoadingMessage', message)
    }

    closeLoading(): void {
        this.emit('closeLoading')
    }

    scrollToTop(): void {
        this.emit('scrollToTop')
    }

    async showHeadingAreaMessage(
        params: HeadingAreaMessageParams | BaseHttpError, includeItemError: boolean = false
    ): Promise<void> {
        await this.waitNextEventLoop()
        this.emit('showHeadingAreaMessage', params, includeItemError)
    }
}
